import * as z from "zod";
import { hsaOrderContext } from "../hsa-order-context";
import { hsaSessionState } from "./types";

export const getCurrentHsaGroupInput = z.object({
  sessionToken: z.string().uuid(),
});

export const getCurrentHsaGroupOutput = z.object({
  state: hsaSessionState,
  // Null for STOREFRONT-initiated sessions (no cart yet). The portal
  // renders the right-rail order summary only when this is non-null;
  // the storefront modal ignores it entirely.
  orderContext: hsaOrderContext.nullable(),
  // Null for STOREFRONT-initiated sessions — the modal closes in place
  // on completion instead of redirecting.
  completedRedirectUrl: z.string().url().nullable(),
});
